import StyledInput from 'components/styledInput/StyledInput';

/**
 * One choice among a few, as a framed list with a radio on each line (the
 * commercial of « Marquer perdu », the reason of « Non réalisé »).
 * `options`: [{ value, label, content }], a label may be a node; `content`:
 * fields of that choice, drawn in its line once it is chosen (a new contact);
 * `empty`: what the frame says when there is no option.
 */
const RadioCardList = ({ name, label, options, value, onChange, empty = null }) => (
  <div role="radiogroup" aria-label={label} className="min-w-0 overflow-hidden rounded-lg border border-gray-100 bg-white">
    <ul className="divide-y divide-gray-100">
      {options.map((option) => (
        <li key={option.value} className="flex flex-col gap-4 px-5 py-4 hover:bg-gray-50">
          <StyledInput
            type="radio"
            name={name}
            label={option.label}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
          />
          {value === option.value && option.content}
        </li>
      ))}
    </ul>
    {!options.length && empty && <p className="px-5 py-4 text-sm text-gray-600">{empty}</p>}
  </div>
);

export default RadioCardList;
